// extracted by mini-css-extract-plugin
export default {"all_tabs":"reclamo_tabs_all_tabs__zfi1c","tabs":"reclamo_tabs_tabs__3Eky2","active":"reclamo_tabs_active__w-wZa"};